import React from 'react';
import { compose } from 'react-apollo';
import { Link } from 'react-router-dom';
import { getUserData } from 'utils/graphQLFunctions';
import TournamentIcon from 'resources/FeatureIcons/Button-Tournaments.svg';
import DesktopNotification from '../DesktopNotification';

function TournamentFinalized({
  tournamentId,
  name,
  leaderBoard,
  userData,
  winningPlaces,
  ...rest
}) {
  const getWinnerRank = () => {
    const winningRanks = new Set(
      winningPlaces.winningPlaces.map(place => place.place)
    );

    const winningEntry = leaderBoard.rankings.find(
      ranking =>
        ranking.player.userId === userData?.user?.userId &&
        winningRanks.has(ranking.rank)
    );

    return winningEntry ? winningEntry.rank : null;
  };
  const rank = getWinnerRank();

  if (!rank) {
    rest.onClose(rest.notificationId);
  }

  return (
    <DesktopNotification
      className="notification-tournament-finalized"
      title={`Tournament ${name}`}
      content={`Congratulation! You are a winner (Ranking ${rank}) of ${name}! Check out your award`}
      iconSrc={TournamentIcon}
      footer={
        <Link
          className="btn btn-success notification-tournament-finalized-button"
          to={'/rewards'}
          onClick={e => {
            rest.onClose(rest.notificationId);
          }}
        >
          <span>Rewards</span>
        </Link>
      }
      {...rest}
    />
  );
}

export default compose(
  getUserData({
    name: 'userData'
  })
)(TournamentFinalized);
